import { render } from "./klbfu.vue?vue&type=template&id=498748dc&scoped=true"
import script from "./klbfu.vue?vue&type=script&lang=js"
export * from "./klbfu.vue?vue&type=script&lang=js"

import "./klbfu.vue?vue&type=style&index=0&id=498748dc&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498748dc"]])

export default __exports__